import type { ComponentProps, ReactNode } from "react";

import { TableCell, TableRow } from "@/components/ui/table";
import { cn } from "@/lib/utils";

interface DocumentSubRowProps extends ComponentProps<typeof TableRow> {
  name: ReactNode;
  revision?: ReactNode;
  type?: ReactNode;
  updated?: ReactNode;
  actions?: ReactNode;
}

/**
 * An indented row under a document in the project documents table (a previous
 * revision or a page). Cells follow its columns: selection, Name, Latest
 * Revision, Type, Updated, Actions.
 */
export function DocumentSubRow({
  name,
  revision,
  type,
  updated,
  actions,
  className,
  ...rowProps
}: DocumentSubRowProps) {
  return (
    <TableRow className={cn("hover:bg-transparent", className)} {...rowProps}>
      <TableCell />
      <TableCell className="min-w-[280px] ps-10">{name}</TableCell>
      <TableCell>{revision}</TableCell>
      <TableCell>{type}</TableCell>
      <TableCell className="text-sm text-muted-foreground">{updated}</TableCell>
      <TableCell onClick={(event) => event.stopPropagation()}>{actions}</TableCell>
    </TableRow>
  );
}
